import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";

import TopNavV2 from "components/molecules/TopNav/common/TopNavV2";
import ProviderTrackingPageAlerts from "pages/provider/ShipmentTracking/components/ProviderTrackingPageAlerts/ProviderTrackingPageAlerts";
import { capitalizeFirstLetter } from "helpers/commonHelpers";

/**
 * A wrapper component that contains the top nav and the page content.
 */
const Wrapper = function ({
  pagekey,
  pageTitle,
  hideTopNav,
  tabTitle,
  isQuickRequest,
  isConsolidated,
  hideIcons,
  component,
  shipmentIdOnTab,
  isLoading,
  isProviderQuotationPage,
  isProviderTrackingPage,
  fillPage,
  ...props
}: any) {
  const { REACT_APP_ENVIRONMENT_NAME } = import.meta.env;
  const { id } = useParams();
  const wrapperRef: any = useRef();

  const shouldIndicateEnvironment = ["regression", "sandbox"].includes(REACT_APP_ENVIRONMENT_NAME || "");

  useEffect(() => {
    if (shipmentIdOnTab) document.title = `${id} - ${isQuickRequest ? "Quick Request" : tabTitle}`;
    else document.title = `${tabTitle} | Cargobase`;

    if (shouldIndicateEnvironment)
      document.title = `${capitalizeFirstLetter(REACT_APP_ENVIRONMENT_NAME)} | ${document.title}`;
  }, [tabTitle, id]);

  return (
    <div ref={wrapperRef} className={`${fillPage ? "" : "main-content"}`}>
      {isProviderTrackingPage && <ProviderTrackingPageAlerts />}
      <ReactToPrint content={() => wrapperRef.current}>
        {!hideTopNav && (
          <TopNavV2
            isQuickRequest={isQuickRequest}
            isConsolidated={isConsolidated}
            tabTitle={tabTitle}
            isLoading={isLoading}
            isProviderQuotationPage={isProviderQuotationPage}
            isProviderTrackingPage={isProviderTrackingPage}
          />
        )}
        <div {...props}>{component}</div>
      </ReactToPrint>
    </div>
  );
};

Wrapper.propTypes = {
  hideTopNav: PropTypes.bool,
  pagekey: PropTypes.string,
  tabTitle: PropTypes.string.isRequired,
  pageTitle: PropTypes.string,
  component: PropTypes.node.isRequired,
  isQuickRequest: PropTypes.bool,
  hideIcons: PropTypes.bool,
  shipmentIdOnTab: PropTypes.bool,
  isLoading: PropTypes.bool,
  isProviderQuotationPage: PropTypes.bool,
  isProviderTrackingPage: PropTypes.bool,
  fillPage: PropTypes.bool,
};

Wrapper.defaultProps = {
  hideTopNav: false,
  isLoading: false,
  pageTitle: "",
  pagekey: "",
  isQuickRequest: false,
  hideIcons: false,
  shipmentIdOnTab: false,
  isProviderQuotationPage: false,
  isProviderTrackingPage: false,
  fillPage: false,
};

export default Wrapper;
